import { ViewModelMessage } from "binder";

export class ServerNotificationMessage extends ViewModelMessage{
    process(addon: ServerNotification, connection: any):Promise<any>{
        return Promise.resolve();
    }
}
export class RegisterForServerNotification extends ServerNotificationMessage{
    public command:string;
    public eventListenner:(command:string,parameter:Object)=>void;

    constructor(command:string,listenner:(command:string,parameter:Object)=>void) {
        super();
        this.command = command;
        this.eventListenner = listenner;
    }

    process(serverConnection: ServerNotification, connection: any):Promise<any>{
        serverConnection._eventMultiplexer.addListenner(this.command,this.eventListenner);
        return Promise.resolve();
    }
}
export class UnregisterForServerNotification extends ServerNotificationMessage{
    public command:string;
    public eventListenner:(command:string,parameter:Object)=>void;

    constructor(command:string,listenner:(command:string,parameter:Object)=>void) {
        super();
        this.command = command;
        this.eventListenner = listenner;
    }
    
    process(serverConnection: ServerNotification, connection: any):Promise<any>{
        serverConnection._eventMultiplexer.removeListenner(this.command,this.eventListenner);
        return Promise.resolve();
    }
}

class EventMultiplexer{
    private _map : {[id:string]:[(command:string,parameter:Object)=>void]}={}
    constructor() {
        
    }
    private removeItemAll(arr, value) {
        var i = 0;
        while (i < arr.length) {
            if (arr[i] === value) {
                arr.splice(i, 1);
            } else {
                ++i;
            }
        }
        return arr;
    }
    raise(command:string,parameter:object){
        if(this._map[command]!=undefined){
            this._map[command].forEach(x=>x(command,parameter));
        }
    }
    public addListenner(command:string,callback:(command:string,parameter:Object)=>void){
        if(this._map[command]==undefined){
            this._map[command]=<any>[];
        }
        this._map[command].push(callback)
    }
    public removeListenner(command:string,callback:(command:string,parameter:Object)=>void){
        this.removeItemAll(this._map[command],callback);
    }
}
export class ServerNotification{
    private _connectionTimer;
    private _isConnected:boolean;
    private _connection;
    public _eventMultiplexer : EventMultiplexer;
    private username:()=>string;
    private password:()=>string;
    constructor(username:()=>string,password:()=>string) {
        this._isConnected = false;
        this._eventMultiplexer = new EventMultiplexer();
        this.username = username;
        this.password = password;
        this.tryConnect();   
        
    }

    private tryConnect(){
        try{
            this.connect();
        }catch(e){
            this.onConnectionLost();
        }

    }

    
    private connect(){
        // let url = "/signalr";
        // let url = "http://localhost:59874/signalr";
        let url = "https://sale.iranautoparts.com/signalr";
        $.getScript(`${url}/signalr/hubs`,x=>this.setupConnection(url)).fail(x=>this.onConnectionLost());
    }
    private setupConnection(url){
        try{
            let connection = (<any>$).hubConnection(url);
            connection.batisPushNotificationHub=connection.createHubProxies().batisPushNotificationHub;
            this.setupEvents(connection);
            connection.qs={Username:this.username(),Password:this.password()};
            connection.start()
                .done(()=>{
                    this._connection = connection; 
                    this._isConnected=true;
                })
                .fail(()=>this.onConnectionLost());
            connection.disconnected(()=>this.onConnectionLost());
        }catch(e){
            this.onConnectionLost();
        }
    }
    private setupEvents(connection){
        connection.batisPushNotificationHub.client.NewPushNotification = (username,command,parameter)=>{
            this._eventMultiplexer.raise(command,JSON.parse(parameter));
        };
    }

    private onConnectionLost(){
        console.log("reconnecting");
        this._isConnected = false;
        clearTimeout(this._connectionTimer);
        this._connectionTimer = setTimeout(x=>this.tryConnect(),1000);
    }
    async handleMessage(msg: ServerNotificationMessage) {
        return await msg.process(this,this._connection); 
    }
}